import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ConnexionBean } from '../../shared/models/connexion-bean.model';
import { LoginBean } from '../../shared/models/login-bean.model';
import { AuthService } from '../../shared/services/auth.service';

@Component({
	selector: 'app-legacy-login',
	templateUrl: './legacy-login.component.html'
})
/**
 * Gestion de l'authentification classique, via lidia
 */
export class LegacyLoginComponent {

  /**
  * Pour l'appel au back
  */
  private alive = true;

  /**
  * Bean de connexion
  */
	public form: LoginBean;

  /**
  * Si le login est invalide
  */
	public userNameInvalid: Boolean = false;

  /**
  * Si le mot de passe est invalide
  */
	public passwordInvalid: Boolean = false;

  /**
  * Message d'erreur s'il a lieu
  */
  public messageErreur: string = "";

  /**
  * Initialisation
  */
	constructor( private readonly authService: AuthService,
    private cookieService: CookieService,
    private router: Router ) {
		this.form = new LoginBean();
	}

  /**
  * Effectue le login effectif
  */
	public login(): void {
		this.userNameInvalid = false;
		if(this.form.login.length == 0 || this.form.login.indexOf(' ') != -1) {
			this.userNameInvalid = true;
		}

		this.passwordInvalid = false;
		if(this.form.password.length == 0 || this.form.password.indexOf(' ') != -1) {
			this.passwordInvalid = true;
		}

    if(!this.userNameInvalid || !this.passwordInvalid) {
      this.authService.legacyLogin(this.form).takeWhile(() => this.alive).subscribe(
        (result: ConnexionBean) => {
          if(result.teledeclarantBean == null) {
            this.messageErreur = "Le login a échoué";
          } else {
            this.messageErreur = "";
            // Path explicite ('/') pour rester cohérent avec les cookies posés depuis les autres
            // routes (ex : '/home/cerfa') et garantir une suppression fiable à la déconnexion.
            this.cookieService.set( 'sub', result.teledeclarantBean.sub, undefined, '/' );
            this.cookieService.set( 'given_name', result.teledeclarantBean.given_name, undefined, '/' );
            this.cookieService.set( 'idCerfa', result.idCerfa, undefined, '/' );
            this.cookieService.set( 'email', result.teledeclarantBean.email, undefined, '/' );
            // On garde le login dans le cookie, afin de pouvoir en récupérer des infos si nécessaire
            this.cookieService.set( 'legacyLogin', this.form.login, undefined, '/' );
            this.router.navigate(['/home/cerfa']);
          }
        },
        err => {
          this.messageErreur = "Le login a échoué";
        }
      );
    }
	}

  /**
  * Style pour chaque champ, si le champ a un problème ou non (issue)
  */
  public getFieldClass(issue: Boolean): string {
    if(issue) {
      return "is-invalid form-control";
    } else {
      return "form-control";
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/legacy-login/legacy-login.component.ts